import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation DismissProcess($process: ProcessEssentialsDismissInput!) {
    dismissProcess(process: $process)
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.DismissProcessMutation,
  boolean | undefined,
  'dismissProcess'
>('dismissProcess', transformers.PASS_THROUGH)

export const executor = graphql.createExecutor<
  graphql.schema.DismissProcessMutation,
  void,
  graphql.schema.DismissProcessMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
